<template>
  <modal v-if="isOpen" class-name="helpbox-modal" @close="$emit('close')">
    <template #body>
      <HelpboxContent :onClose="() => $emit('close')"/>
    </template>
  </modal>
</template>

<script>
import HelpboxContent from '../../landing-components/HelpboxContent.vue';
import Modal from '../common/Modal.vue';

export default {
  components: {
    Modal,
    HelpboxContent,
  },
  props: ['isOpen'],
};
</script>
<style lang="scss">
  .helpbox-modal {
    min-width: 100vw !important;
    min-height: 100vw !important;

    .modal-overlay {
      background: rgba(19, 19, 19, 0.85);
    }
    .modal-wrapper {
      .modal-container {
        background: none;
        box-shadow: none;
        padding-left: 0;
        padding-right: 0;
        
        .modal-close-btn {
          left: 50%;
          transform: translateX(250%);
          top: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/HelpboxModal.vue